import { maxSizeDesktop, spacingExtraLarge, spacingMedium } from 'helpers/style';
import { Text } from '../../common/text';
import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(p) => p.theme.color.redDark};
    border-radius: ${(p) => p.theme.borderRadius.medium};

    padding: ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding: ${spacingMedium};
    }

    width: 100%;
    padding: 20px;
`;

export const Heading = Text.withComponent('h2');
